import { useCallback } from "react";

import { getUUID } from "@/lib/uuid/get-uuid";

import type { FormOptionType } from "@/components/ui/form/_types/type";

import { useAccommodationHotelPolicyFormModelContext } from "../../../../../../../context";

const NOT_SET = "null";
const NOT_SET_FORM_OPTION_ITEM = {
	id: getUUID(),
	label: "未選択",
	value: NOT_SET,
} satisfies FormOptionType;

export const useReservationDefaultPlanID = () => {
	const { viewModel, onSetViewModel, queryData } = useAccommodationHotelPolicyFormModelContext();
	const { defaultPlanID } = viewModel;
	const { planList } = queryData;

	const isEdited = defaultPlanID?.isEdited;
	const hasError = Boolean(defaultPlanID?.error);

	const inSalePlans = planList.filter((plan) => plan.inSale);

	const defaultPlanIDOptions = [
		NOT_SET_FORM_OPTION_ITEM,
		...inSalePlans.map((plan) => {
			return {
				id: plan.planID,
				label: plan.name,
				value: plan.planID,
			} satisfies FormOptionType;
		}),
	] satisfies FormOptionType[];

	const onSetRequiredDefaultPlanID = useCallback(
		(input: string) => {
			const value = input === NOT_SET ? null : input;

			onSetViewModel([
				{
					key: "defaultPlanID",
					value: {
						isEdited: true,
						value,
					},
				},
			]);
		},
		[onSetViewModel],
	);

	return {
		isEdited,
		hasError,

		defaultPlanIDOptions,
		defaultPlanID,
		onSetRequiredDefaultPlanID,
	};
};
